import { render, staticRenderFns } from "./ImportStu.vue?vue&type=template&id=14fd43f9"
import script from "./ImportStu.vue?vue&type=script&lang=js"
export * from "./ImportStu.vue?vue&type=script&lang=js"
import style0 from "./ImportStu.vue?vue&type=style&index=0&id=14fd43f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports